module.exports = function() {
    var deferred = $.Deferred();

    var pluginInfo = {};

    function populatePluginInfo(detector, pluginName) {
        var info = detector.getVersion(pluginName);
        pluginInfo[pluginName] = {
            installed : (info != null),
            version : (info != null) ? info : 0
        };
    }

    ["Flash", "Silverlight"].forEach(function(name) {
        populatePluginInfo(PluginDetect, name);
    });

    function onJavaDetectionDone(pd) {
        populatePluginInfo(pd, "Java");
        deferred.resolve();
    }
    PluginDetect.onDetectionDone("Java", onJavaDetectionDone, "js/lib/getJavaInfo.jar");

    this.browser = this.browser || {};
    this.browser.plugins = {
        getInfo : function(pluginName) {
            return pluginInfo[pluginName];
        }
    };

    return deferred.promise();
};